import React from 'react';
import email from '../img/email.png';
import call from '../img/call.png';
import location from '../img/location.png';
import fb from '../img/fb.png';

const Contact = () => {
    return (
        <section id="contact" className="container pt-3 py-md-5">
        <h1 className="text-center title mt-md-3"><b>Contact</b></h1>

            <div className="row mt-5 text-md-center">
                <div className="col-md-6">
                    <h4 className="d-flex align-items-center pl-3 pl-sm-5">
                        <img src={email} width="30px" className="mr-3" alt="" />
                        <a href="mailto:sihah8938@gmail.com">sihah8938@gmail.com</a>
                    </h4>
                    <h4 className="d-flex align-items-center pl-3 pl-sm-5">
                        <img src={call} width="30px" className="mr-3" alt="" />
                        <a href="tel:+8801677-685551">+8801677-685551</a>
                    </h4>
                </div>
                <div className="col-md-6">
                    <h4 className="d-flex align-items-center pl-3 pl-sm-5">
                        <img src={location} width="30px" className="mr-3" alt="" />
                        <a href="https://g.page/NSM2017?share">Maijdee, Noakhali</a>
                    </h4>
                    <h4 className="d-flex align-items-center pl-3 pl-sm-5">
                        <img src={fb} width="30px" className="mr-3" alt="" />
                        <a className="" href="https://fb.com/sihah58">fb.com/sihah58</a>
                    </h4>
                </div>
            </div>
        </section>
    );
};

export default Contact;